import React, {ReactElement} from "react";
import {Box, createStyles, fade, Link, Theme, Typography} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export interface DashboardPanelProps {
  title: string;
  children: ReactElement[] | ReactElement;
  addPanel?: ReactElement;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dashboardPanelTitle: {
      background: fade(theme.palette.primary.main, 0.1),
      height: 60,
      lineHeight: '1em',
      minWidth: '100%',
      paddingLeft: theme.spacing(3),
      paddingTop: theme.spacing(1.5),
      marginBottom: theme.spacing(-2),
      marginLeft: theme.spacing(-1),

        [theme.breakpoints.up('md')]: {
          height: 86,
          minWidth: 207,
          paddingLeft: theme.spacing(5),
          paddingTop: theme.spacing(2.5),
          marginBottom: theme.spacing(-3),
          marginLeft: theme.spacing(-2),
        }
    },
    dashboardPanelTabLink: {
      cursor: 'pointer',
      fontWeight: 700,
      marginRight: theme.spacing(2),
      opacity: 0.3,

      [theme.breakpoints.down('sm')]: {
        '&:last-child': {
          marginRight: 0
        }
      }
    },
    dashboardPanelTabLinkActive: {
      opacity: 1
    }
  }),
);

export const DashboardPanel = (props: DashboardPanelProps) => {

  const children = Array.isArray(props.children) ? props.children : [props.children]
  const [selectedTab, setSelectedTab] = React.useState<number>(0);

  const classes = useStyles();

  return (
    <Box height='100%'
         display='flex'
         flexDirection='column'
         pb={{xs: props.addPanel ? 5 : 0, md: 2.5}}
    >
      <Box display='flex'
           justifyContent={{md: 'space-between'}}
           alignItems={{md: 'flex-end'}}
           flexDirection={{xs: 'column-reverse', md: 'row'}}
      >
        <Box display={{xs: 'flex', md:'inline-flex'}}>
          <Typography component="h2"
                      variant="subtitle1"
                      color='primary'
                      className={classes.dashboardPanelTitle}
          >
            {props.title}
          </Typography>
        </Box>
        { children.length > 1 ? (
          <Box component='nav'
               pb={{xs: 1, md: 2}}
               pr={1}
               textAlign='right'>
            {children.map((item, index) => (
              <Link key={index}
                    onClick={() => setSelectedTab(index)}
                    color={'primary'}
                    className={`${classes.dashboardPanelTabLink} ${selectedTab === index ? classes.dashboardPanelTabLinkActive : null}`}
              >
                {item.props.tabtitle}
              </Link>
            ))}

          </Box>
        ) : null}
      </Box>

      <Box bgcolor='common.white'
           height={{xs: 320, md: 400}}
           overflow='auto'
           px={{xs: 2, md: 3}}
           pt={2}
      >
        {children[selectedTab]}
      </Box>
      {props.addPanel ? (
        <Box display='flex' justifyContent='flex-end'>
          {props.addPanel}
        </Box>
      ) : null }
    </Box>
  )  
};
